export default {
	"billingItems": {
		"name": "ชื่อรายการการเรียกเก็บเงิน",
		"type": "ระดับ",
		"billingItemInfo": "รายการการเรียกเก็บเงิน",
		"billingItemCodeTips": "กรุณากรอกรหัสรายการเรียกเก็บเงิน (สูงสุด 32 ตัวอักษร)",
		"billingItemNameTips": "กรุณากรอกชื่อรายการเรียกเก็บเงิน (สูงสุด 32 ตัวอักษร)",
		"addBillingItem": "เพิ่มชื่อรายการเรียกเก็บเงิน",
		"trunk": "การขนส่งระหว่างคลังสินค้า",
		"distribution": "การจัดส่งถึงบ้าน",
		"storage": "คลังสินค้า",
		"appreciation": "บริการเพิ่มมูลค่า"
	},
	"billingRules": {
		"ruleName": "ชื่อเกณฑ์",
		"remark": "คำอธิบายเกี่ยวกับเกณฑ์",
		"rule": "เกณฑ์การคำนวณ",
		"billingRule": "เกณฑ์การเรียกเก็บเงิน",
		"ruleTips": "กรุณากรอกเกณฑ์การคำนวณ (สูงสุด 6000 ตัวอักษร)",
		"ruleTest": "ท่านสามารถทดสอบที่นี่",
		"invokeParam": "กรอกค่าพารามิเตอร์ที่จำเป็นสำหรับทดลองการคำนวณ (สูงสุด 2,000 คำ)",
		"startTest": "เริ่มการทดสอบ",
		"getReturnResult": "คลิ๊กเริ่มทดสอบและส่งคืนผลการทดสอบ",
		"addBillingRules": "เพิ่มเกณฑ์การเรียกเก็บเงิน"
	},
	"billingShares": {
		"shareName": "ชื่อเกณฑ์การจัดสรร",
		"rule": "การกำหนดค่าการจัดสรร",
		"shareNameTips": "กรุณากรอกชื่อเกณฑ์การจัดสรร (สูงสุด 20 ตัวอักษร)",
		"ruleCodeTips": "กรุณากรอกรหัส (สูงสุด 32 ตัวอักษร)",
		"ruleTips": "กรุณากรอกการกำหนดค่าการจัดสรร (สูงสุด 6000 ตัวอักษร)",
		"invokeParam": "กรอกค่าพารามิเตอร์ที่จำเป็นสำหรับทดลองการคำนวณ (สูงสุด 500 ตัวอักษร)",
		"addShareRules": "เพิ่มเกณฑ์การจัดสรร"
	},
	"calculatorManage": {
		"name": "มาตรวัด",
		"date": "วันที่",
		"time": "เวลา",
		"manualTrigger": "ทริกเกอร์แบบแมนนวล",
		"calculatorInfo": "ข้อมูลผู้เรียกเก็บเงิน",
		"nameTips": "กรุณากรอกชื่อมาตรวัด(สูงสุด 32 ตัวอักษร)",
		"realTime": "เรียลไทม์",
		"everyday": "รายวัน",
		"calculationTask": "งานการคำนวณ",
		"calculationTaskConfig": "กำหนดค่างานการคำนวณ",
		"quoteTypeTips": "กรุณาเลือกประเภทสัญญาก่อน",
		"addCalculator": "เพิ่มมาตรวัด",
		"number": "ไม่มี",
		"spot": "จุด",
		"refreshTips": "ไม่สามารถโหลดข้อมูลพื้นฐานได้ กรุณากด f5 เพื่อรีเฟรชหน้าและลองอีกครั้ง"
	},
	"contractManage": {
		"contractNoLike": "ชื่อสัญญา/หมายเลขสัญญาภายนอก",
		"serviceProducts": "สินค้าบริการ/โครงการ",
		"createDtInitData": "กำหนดระยะเวลา",
		"startInitData": "ระยะเวลาที่มีผลบังคับ",
		"endInitData": "ระยะเวลาหมดอายุ",
		"renew": "ต่ออายุ",
		"switch": "สลับ",
		"dateChange": "ปรับเปลี่ยนวันที่มีผลบังคับ",
		"quoteMaintain": "จัดทำเอกสารข้อมูลราคา",
		"fileAdmin": "การจัดการเอกสารแนบ",
		"mainContractNo": "หมายเลขสัญญาหลัก",
		"pleaseInputLightRatio": "กรุณากรอกอัตราส่วนปริมาตร/น้ำหนัก (ตัวเลขที่มากกว่า 0 และน้อยกว่า 999)",
		"contractRenewal": "ต่ออายุสัญญา",
		"contractSwitch": "เปลี่ยนสัญญา",
		"splitData": "วันที่เปลี่ยน",
		"contractFileAdmin": "การจัดการเอกสารแนบท้ายสัญญา",
		"addContract": "จัดทำสัญญา",
		"threeMonthsAgo": "สามเดือนก่อน",
		"aMonthsAgo": "เดือนที่ผ่านมา",
		"aWeekAgo": "สัปดาห์ที่ผ่านมา",
		"aWeekLater": "สัปดาห์ถัดไป",
		"aMonthsLater": "เดือนถัดไป",
		"threeMonthsLater": "สามเดือนที่ผ่านมา",
		"noProductInformation": "ข้อมูลสินค้าที่ไม่ได้รับทราบ",
		"duplicateProductInformation": "ข้อมูลสินค้าซ้ำซ้อน",
		"nocontractData": "ข้อมูลสัญญาที่ไม่ได้รับทราบ",
		"contractCannotBeDeleted": "ไม่สามารถลบสัญญา",
		"onlyNewCanBeDeleted": "ลบได้เฉพาะสัญญาที่ทำขึ้นใหม่เท่านั้น",
		"pleaseSelectDate": "กรุณาเลือกวันที่มีผลบังคับและวันหมดอายุ",
		"errDateTips": "วันที่มีผลบังคับใช้ต้องไม่เกินวันหมดอายุ",
		"confirmRenew": "ท่านแน่ใจว่าต้องการต่ออายุสัญญาใช่หรือไม่?",
		"pleaseSelectSwitchingDate": "กรุณาเลือกวันที่จะสับเปลี่ยน",
		"confirmSwitch": "ท่านแน่ใจว่าต้องการสับเปลี่ยนใช่หรือไม่?",
		"sequenceNoTips": "กรุณากรอกหมายเลขซีเรียล",
		"curSequenceNo": "หมายเลขซีเรียลปัจจุบันคือ",
		"inputTips": "กรุณากรอกจำนวนเต็มไม่เกิน 7 หลัก"
	},
	"dataResource": {
		"sourceFeture": "คุณสมบัติของแหล่งข้อมูล",
		"dataResourceInfo": "ข้อมูลเกี่ยวกับแหล่งข้อมูล",
		"dataResourceTips": "กรุณากรอกชื่อแหล่งข้อมูล (สูงสุด 20 ตัวอักษร)",
		"sourceType": "ประเภทของแหล่งข้อมูล",
		"sourceFetureTips": "กรุณาเลือกคุณสมบัติของแหล่งข้อมูล",
		"sourceContextTips": "กรุณากรอกการกำหนดค่า (ไม่เกิน 4000 ตัวอักษร)",
		"testTips": "ท่านสามารถทดสอบที่นี่",
		"inputTips": "กรอกค่าพารามิเตอร์ (สูงสุด 500 ตัวอักษร)",
		"addDataResource": "กรอกแหล่งข้อมูล"
	},
	"motherTemplate": {
		"motherboardName": "ชื่อเทมแพลต",
		"downloadMotherboard": "ดาวน์โหลดเทมเพลต",
		"upload": "อัพโหลด",
		"motherboardInfo": "ข้อมูลเทมเพลต",
		"quoteMotherboardName": "ชื่อแบบฟอร์มเอกสารข้อมูลราคา",
		"addMotherboard": "เพิ่มแบบฟอร์ม"
	},
	"quoteMaintain": {
		"quotationTemplate": "แบบฟอร์มเอกสารข้อมูลราคา",
		"content": "เนื้อหา",
		"importQuotation": "นำเข้าเอกสารข้อมูลราคา",
		"exportQuotation": "ส่งออกเอกสารข้อมูลราคา",
		"clearQuotation": "ลบใบเสนอราคา",
		"pleaseClick": "กรุณาคลิ๊กที่แบบฟอร์มใบเสนอราคาด้านบน",
		"importQuotationSuccess": "นำเข้าเอกสารข้อมูลราคาสำเร็จ",
		"revokeOperation": "ท่านแน่ใจว่าต้องการยกเลิกการดำเนินงานใช่หรือไม่?",
		"changeNew": "ท่านแน่ใจว่าต้องการเปลี่ยนสถานะสัญญาเป็น \"ใหม่\" ใช่หรือไม่?",
		"noTemplateNotQuotation": "ไม่สามารถนำเข้าใบเสนอราคาหากไม่มีแบบฟอร์มใบเสนอราคา กรุณาอัพโหลดแบบฟอร์มแล้วลองอีกครั้ง",
		"contractAdmin": "การจัดการสัญญา",
		"noserviceProduct": "ท่านยังไม่ได้ตั้งค่าสินค้าบริการ!"
	},
	"serviceitems": {
		"choseNode": "เลือกเวลา",
		"serviceType": "เลือกประเภทบริการ",
		"serviceName": "ชื่อการบริการ",
		"serviceNameTips": "กรุณากรอกชื่อบริการ (สูงสุด 32 ตัวอักษร)",
		"provider": "เซิร์ฟเวอร์",
		"synmode": "การประสานข้อมูลธุรกิจ",
		"codeTips": "กรุณากรอกรหัส (สูงสุด 32 ตัวอักษร)",
		"custom": "การปรับแต่งธุรกิจ",
		"unit": "หน่วยการเสนอราคา",
		"unitTips": "กรุณากรอกหน่วยการเสนอราคา (สูงสุด 32 ตัวอักษร)",
		"addService": "รายการบริการใหม่",
		"inputSequenceNo": "กรุณากรอกหมายเลขซีเรียล",
		"curSequenceNo": "หมายเลขซีเรียลปัจจุบันคือ",
		"inputErrorMessage": "กรุณากรอกจำนวนเต็มไม่เกิน 7 หลัก"
	},
	"account": {
		"companyName": "ชื่อบริษัท",
		"businessLicense": "ใบอนุญาตประกอบธุรกิจเลขที่",
		"nature": "กลุ่มธุรกิจ",
		"parentCompany": "บริษัทแม่",
		"shortName": "ตัวย่อ",
		"address": "ที่อยู่ทางไปรษณีย์",
		"contact": "กรุณากรอกชื่อผู้ติดต่อ",
		"addContact": "เพิ่มบุคคลติดต่อ",
		"mobile": "โทรศัพท์มือถือ",
		"email": "อีเมล",
		"duty": "ตำแหน่งงาน",
		"uploadLogo": "อัพโหลดโลโก้"
	}
}


// WEBPACK FOOTER //
// ./src/lang/th/pages/account/account.js